// if NODE_ENV === production, return 
function getPathPrefix(path) {
    return (
        process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_PATH_PREFIX}${path.startsWith('/') ? path : `/${path}`}` : path
    );
}

export default getPathPrefix;